import React, { createContext, useContext, useEffect, useState } from "react";
import { BRANDING_API_URL, resolvePublicAssetUrl, createTimeoutSignal } from "../api";

const BrandingContext = createContext({
  logoSrc: null,
  iconSrc: null,
  updatedAt: null,
  loaded: false,
});

export function BrandingProvider({ children }) {
  const [logoSrc, setLogoSrc] = useState(null);
  const [iconSrc, setIconSrc] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(BRANDING_API_URL, {
          method: "GET",
          credentials: "omit",
          headers: { Accept: "application/json" },
          signal: createTimeoutSignal(12000),
        });
        if (!res.ok || cancelled) return;
        const data = await res.json();
        if (cancelled || !data || typeof data !== "object") return;
        const logo = resolvePublicAssetUrl(data.logo_url);
        const icon = resolvePublicAssetUrl(data.icon_url);
        if (logo) setLogoSrc(logo);
        if (icon) setIconSrc(icon);
        if (data.updated_at != null) setUpdatedAt(String(data.updated_at));
      } catch {
        /* fallback: static assets */
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!iconSrc) return;
    const iconLink = document.querySelector("link#favicon") || document.querySelector('link[rel="icon"]');
    if (iconLink) iconLink.href = iconSrc;
    const apple = document.querySelector('link[rel="apple-touch-icon"]');
    if (apple) apple.href = iconSrc;
  }, [iconSrc]);

  const value = { logoSrc, iconSrc, updatedAt, loaded };
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext);
}
